import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Typography,
  Modal,
  message,
  Space,
} from 'antd'
import { UserOutlined, PhoneOutlined, LockOutlined } from '@ant-design/icons'
import './Common.module.css'
import styles from './Common.module.css'
import { editSchoolAdminRequest, getSchoolTypeListRequest } from '../api'

const { Title } = Typography
const { Option } = Select

const { TextArea } = Input
const EditAccountForm = (props) => {
  const [form] = Form.useForm()
  const [schoolTypeList, setSchoolTypeList] = useState([])
  console.log('accountStatus')
  console.log(props.user)
  // setAccountStatus(props.user.status==1?true:false);
  useEffect(() => {
    initForm()
    getSchoolTypeList()
  }, [props.openStatus])
  function initForm() {
    form.setFieldsValue({
      schoolName: props.user.school_name,
      schoolAddress: props.user.dizhi,
      userName: props.user.name,
      teacherNumber: props.user.teacher_num,
      accountStatus: props.user.status == 1 ? true : false,
      beizhu: props.user.beizhu
    })
  }
  function getSchoolTypeList() {
    getSchoolTypeListRequest((data) => {
      console.log('-------------->>>>>>>>>>>.')
      var newSchoolTypeList = [
        {
          type_name: '未选择',
          type_code: '',
        },
      ]
      if (data.ret == 1) {
        data.data.forEach((element) => {
          newSchoolTypeList.push(element)
        })
      } else {
        message.warning(data.msg)
      }
      setSchoolTypeList(newSchoolTypeList)
      console.log(schoolTypeList)
    })
  }

  const onFinish = (values) => {
    // 这里可以添加API调用或其他提交逻辑
    var userCode = props.user.username
    var school_name =
      values.schoolName == undefined || values.schoolName == ''
        ? props.user.school_name
        : values.schoolName
    var dizhi =
      values.schoolAddress == undefined || values.schoolAddress == ''
        ? props.user.dizhi
        : values.schoolAddress
    var pwd =
      values.pwd == undefined || values.pwd == '' ? props.user.pwd : values.pwd
    var username =
      values.userName == undefined || values.userName == ''
        ? props.user.name
        : values.userName
    var teacherNumber =
      values.teacherNumber == undefined || values.teacherNumber == ''
        ? props.user.teacher_num
        : values.teacherNumber
    var status =
      values.accountStatus == undefined
        ? props.user.status
        : values.accountStatus
          ? '1'
          : '3'
    var beizhu =
      values.beizhu == undefined || values.beizhu == ''
        ? props.user.beizhu
        : values.beizhu
    var school_code =
      values.schoolType == undefined || values.schoolType == ''
        ? props.user.school_type_code
        : values.schoolType
    console.log(values)
    editSchoolAdminRequest(
      userCode,
      school_name,
      dizhi,
      pwd,
      username,
      teacherNumber,
      status,
      beizhu,
      school_code,
      (data) => {
        console.log('ffffffffffffffffffff')
        console.log(data)
        if (data.ret == 1) {
          props.refreshList()
          closeCommon()
        } else {
          message.warning(data.msg)
        }
      },
    )
  }

  const closeCommon = () => {
    form.resetFields()
    props.closeCommonModal()
  }

  return (
    <Modal
      maskClosable={false}
      // visible={true}
      open={props.openStatus}
      onCancel={closeCommon}
      footer={null} // 设置 footer 为 null 移除默认按钮
      width={800}
      // className="add-account-container"
    >
      <Card className={styles['form-card']} span={20}>
        <div className={styles['form-title']}>编辑学校信息</div>
        <Form
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          className="account-form"
        >
          <Form.Item
            label="学校名称"
            name="schoolName"
            rules={[{ required: false, message: '请输入学校名称' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input
              placeholder={props.user.school_name}
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="学校地址"
            name="schoolAddress"
            rules={[{ required: false, message: '请输入学校地址' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input placeholder={props.user.dizhi} size="large" />
          </Form.Item>

          <Form.Item
            label="所属省份"
            name="province"
            rules={[{ required: false, message: '请选择所属省份' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <text>{props.user.shengfen_name}</text>
          </Form.Item>

          <Form.Item
            label="所属地市"
            name="dishi"
            rules={[{ required: false, message: '请选择所属地市' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <text>{props.user.shi_name}</text>
          </Form.Item>
          <Form.Item
            label="所属区县"
            name="quxian"
            rules={[{ required: false, message: '请选择所属区县' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <text>{props.user.quxian_name}</text>
          </Form.Item>
          <Form.Item
            label="学校类型"
            name="schoolType"
            rules={[{ required: false, message: '请选择学校类型' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Select
              onChange={(value, label) => {}}
              defaultValue={props.user.school_type_name}
              options={schoolTypeList.map((item) => {
                return {
                  value: item.type_code,
                  label: item.type_name,
                }
              })}
            ></Select>
          </Form.Item>
          <Form.Item
            label="登录账号"
            name="login"
            rules={[{ required: false, message: '请输入登录账号' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <text>{props.user.user_login}</text>
          </Form.Item>
          <Form.Item
            label="登录密码"
            name="pwd"
            rules={[{ required: false, message: '请输入登录密码' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input.Password
              placeholder="请输入登录密码"
              size="large"
              defaultValue={props.user.pwd}
            />
          </Form.Item>
          <Form.Item
            label="用户名称"
            name="userName"
            rules={[{ required: false, message: '请输入用户名称' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input
              // placeholder="请输入用户名称"
              size="large"
              placeholder={props.user.name}
            />
          </Form.Item>
          {/*<Form.Item*/}
          {/*    label="应用自定义计费设置"*/}
          {/*    name="jifeishezhi"*/}
          {/*    // rules={[{required: true, message: '请输入登录密码'}]}*/}
          {/*    labelAlign="right"*/}
          {/*    labelCol={{span: 5}}*/}
          {/*>*/}
          {/*  <Switch*/}
          {/*      checked={props.checkedStatus}*/}
          {/*      onChange={(checked) => {*/}
          {/*      }}*/}
          {/*      // checkedChildren="开"*/}
          {/*      // unCheckedChildren="关"*/}
          {/*      // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}*/}
          {/*      style={{marginLeft: 10, marginRight: 10}}*/}
          {/*  />*/}
          {/*  <Button*/}
          {/*      type="primary"*/}
          {/*  >*/}
          {/*    去设置*/}
          {/*  </Button>*/}
          {/*</Form.Item>*/}
          <Form.Item
            label="学校账户初始积分"
            name="chushijifen"
            rules={[{ required: false, message: '请输入初始积分' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <text>{props.user.jifen}</text>
          </Form.Item>
          <Form.Item
            label="学校子账号数量"
            name="teacherNumber"
            rules={[{ required: false, message: '请输入子账号数量' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Input placeholder={props.user.teacher_num} size="large" />
          </Form.Item>
          <Form.Item
            label="学校账号状态"
            name="accountStatus"
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <Switch
              // checked={props.checkedStatus}
              onChange={(checked) => {}}
              // checkedChildren="开"
              // unCheckedChildren="关"
              // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
              style={{ marginLeft: 10, marginRight: 10 }}
              defaultChecked={props.user.status == 1}
            />
          </Form.Item>
          <Form.Item
            label="备注"
            name="beizhu"
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <TextArea
              placeholder={props.user.beizhu}

              // value={tishiValue}
              // onChange={changeTishiFn}
              // readOnly={disableCreate}
            />
          </Form.Item>
          <Form.Item className={styles['form-actions']}>
            <Button
              size="large"
              onClick={() => {
                props.closeCommonModal()
                form.resetFields()
              }}
            >
              取消
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ marginLeft: 16 }}
            >
              确认
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Modal>
  )
}

export default EditAccountForm

